export const constants = {
  zenDeskId: "ze-snippet"
};
